module.exports = __webpack_public_path__ + "static/img/liyade6.a027e741.jpg";